<template>
  <div class="">
    <Header2 :donnes="client" />
    <MapsLocalisation />
    <!-- <testMaps /> -->
  </div>
</template>
<script>
import Header2 from "@/components/helper/header2.vue";
import MapsLocalisation from "@/components/container/campagnes/MapsLocalisation.vue";
// import testMaps from "@/components/container/campagnes/GoogleMapsComponent.vue";
import allFunctions from "@/components/utilityRequest/allFunctions";

export default {
  name: "IndexPlan",
  components: {
    Header2,
    MapsLocalisation,
    // testMaps,
  },
  data() {
    return {
      client: null,
    };
  },
  created() {
    this.getCompany();
  },
  methods: {
    async getCompany() {
      const id = this.$route.query.id;
      this.client = await allFunctions.findOne("clients", id);
    },
  },
};
</script>
<style></style>
